import { ROLES } from './roles';

export const FORM_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
};

/**
 * Plantillas de formularios de ejemplo. `totalSubmissions` ya viene
 * desglosado en `approvedCount` / `pendingCount` / `rejectedCount` para
 * poder alimentar el dashboard del analista sin cálculos adicionales.
 *
 * @typedef {Object} FormTemplate
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} category
 * @property {number} fieldsCount
 * @property {'active'|'draft'|'archived'} status
 * @property {string[]} assignedRoles
 * @property {string} createdAt ISO date
 * @property {number} totalSubmissions
 * @property {number} approvedCount
 * @property {number} pendingCount
 * @property {number} rejectedCount
 */

/** @type {FormTemplate[]} */
export const FORMS = [
  {
    id: 'f1',
    title: 'Encuesta de satisfacción ciudadana',
    description: 'Percepción de la comunidad sobre los servicios públicos del barrio.',
    category: 'Encuestas',
    fieldsCount: 12,
    status: FORM_STATUS.ACTIVE,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-05-04',
    totalSubmissions: 128,
    approvedCount: 96,
    pendingCount: 22,
    rejectedCount: 10,
  },
  {
    id: 'f2',
    title: 'Visita de verificación de obra',
    description: 'Inspección de avance físico en proyectos de infraestructura.',
    category: 'Infraestructura',
    fieldsCount: 18,
    status: FORM_STATUS.ACTIVE,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-05-18',
    totalSubmissions: 64,
    approvedCount: 40,
    pendingCount: 18,
    rejectedCount: 6,
  },
  {
    id: 'f3',
    title: 'Registro de atención en salud comunitaria',
    description: 'Seguimiento a jornadas de salud en zonas rurales.',
    category: 'Salud',
    fieldsCount: 15,
    status: FORM_STATUS.ACTIVE,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-06-01',
    totalSubmissions: 87,
    approvedCount: 70,
    pendingCount: 12,
    rejectedCount: 5,
  },
  {
    id: 'f4',
    title: 'Diagnóstico de seguridad vial',
    description: 'Puntos críticos de accidentalidad reportados por la comunidad.',
    category: 'Movilidad',
    fieldsCount: 10,
    status: FORM_STATUS.DRAFT,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-06-20',
    totalSubmissions: 0,
    approvedCount: 0,
    pendingCount: 0,
    rejectedCount: 0,
  },
  {
    id: 'f5',
    title: 'Censo de comerciantes informales',
    description: 'Caracterización socioeconómica de vendedores ambulantes.',
    category: 'Economía',
    fieldsCount: 20,
    status: FORM_STATUS.ACTIVE,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-04-22',
    totalSubmissions: 53,
    approvedCount: 30,
    pendingCount: 15,
    rejectedCount: 8,
  },
  {
    id: 'f6',
    title: 'Reporte de mantenimiento de parques',
    description: 'Estado de zonas verdes y mobiliario urbano.',
    category: 'Infraestructura',
    fieldsCount: 9,
    status: FORM_STATUS.ARCHIVED,
    assignedRoles: [ROLES.DATA_ENTRY],
    createdAt: '2026-02-10',
    totalSubmissions: 41,
    approvedCount: 35,
    pendingCount: 0,
    rejectedCount: 6,
  },
];
